import React from "react";
import Seo from "./Seo";

export const LegalPage = ({ pageKey, title, intro, seoDesc, updated, sections }) => (
  <div>
    <Seo pageKey={pageKey} title={`${title} | MyCleaner.ch`} description={seoDesc} />
    <section className="pt-[116px] pb-10 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-[760px] mx-auto px-5 md:px-6">
        <h1 className="font-head font-extrabold text-4xl sm:text-5xl text-slate-900 mb-3 break-words hyphens-auto" lang="de">{title}</h1>
        <p className="text-slate-600">{intro}</p>
        <p className="text-xs text-slate-400 mt-2">Stand: {updated}</p>
      </div>
    </section>
    <section className="pb-20">
      <div data-testid={`${pageKey}-content`} className="max-w-[760px] mx-auto px-5 md:px-6 space-y-8">
        {sections.map((s, i) => (
          <div key={s.h}>
            <h2 className="font-head font-bold text-lg text-slate-900 mb-2">{i + 1}. {s.h}</h2>
            {(s.p || []).map((t) => <p key={t} className="text-slate-600 leading-relaxed mb-2 text-sm md:text-base whitespace-pre-line">{t}</p>)}
            {(s.items || []).map((it, k) => typeof it === "string"
              ? <p key={k} className="text-slate-600 leading-relaxed mb-2 text-sm md:text-base whitespace-pre-line">{it}</p>
              : it.h ? <h3 key={k} className="font-semibold text-slate-800 mt-4 mb-1">{it.h}</h3>
              : <ul key={k} className="list-disc pl-5 space-y-1 mb-2 text-slate-600 text-sm md:text-base">{it.ul.map((t) => <li key={t}>{t}</li>)}</ul>)}
            {s.ul && <ul className="list-disc pl-5 space-y-1 mb-2 text-slate-600 text-sm md:text-base">{s.ul.map((t) => <li key={t}>{t}</li>)}</ul>}
            {(s.p2 || []).map((t) => <p key={t} className="text-slate-600 leading-relaxed mb-2 text-sm md:text-base">{t}</p>)}
          </div>
        ))}
      </div>
    </section>
  </div>
);
